import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from '../components/AppSidebar';
import '../scss/Layout.scss';

const DefaultLayout = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const handleSidebarToggle = (expanded) => {
    setIsSidebarExpanded(expanded);
    // Update CSS variable for main content
    document.documentElement.style.setProperty(
      '--sidebar-width', 
      expanded ? '250px' : '60px'
    );
  };

  useEffect(() => {
    const handleCustomEvent = (event) => {
      setIsSidebarExpanded(event.detail.isExpanded);
      document.documentElement.style.setProperty(
        '--sidebar-width', 
        event.detail.isExpanded ? '250px' : '60px'
      );
    };

    window.addEventListener('sidebarToggle', handleCustomEvent);
    document.documentElement.style.setProperty('--sidebar-width', '60px');
    
    return () => {
      window.removeEventListener('sidebarToggle', handleCustomEvent);
      document.documentElement.style.removeProperty('--sidebar-width');
    };
  }, []);

  return (
    <div className="layout-container">
      <AppSidebar onToggle={handleSidebarToggle} />
      <div className={`main-content ${isSidebarExpanded ? 'expanded' : ''}`}>
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;